/**
 * Generated runtime TestId mirror for frontend/src/pages/RequestDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const RequestDetailTestIds = {
  cardTitleWaterfall: "card-title-waterfall",
  requestDetailPage: "request-detail-page"
} as const;
